// Error Code from https://github.com/nutanix-core/iam-user-authn/blob/master/connector/statusCodes.go
import { CHANGE_PASSWORD_URL, HOME_URL } from '../constant';
import getI18nService from '../i18n/I18n';
import { forceRedirect } from './common';

const i18n = getI18nService();

const errorCodeMapper = {
    'IAM-23104': 'invalidCredentials',
    'IAM-23105': 'invalidCredentials',
    'IAM-21005': 'invalidCredentials',
    'IAM-20002': 'invalidCredentials',
    'IAM-21420': 'error28',
    'IAM-20502': 'error500',
    'IAM-21423': 'userLockedOut',
};

const errorRedirectMapper = {
    // Redirect to home page for session timeout
    'IAM-23102': HOME_URL,
    // Redirect to change password page for password expired
    'IAM-23106': CHANGE_PASSWORD_URL,
};

const getFullErrorMsg = errorCodeMsg => {
    return i18n.t('ErrorMessages.errorMessage', {
        error_code: errorCodeMsg,
    });
};

// Replace all nonumerical digit in string, e.g. '19' from 'ec=ERR-19'
const getNumFromStr = str => str.replace(/\D/g, '');
/**
 * Handles inputs change to set values in state
 * @param {String} errorParaStr - error message code string
 * @returns {String} error message content
 */
export const getErrorMsg = errorParaStr => {
    if (!errorParaStr || errorParaStr === '') {
        return '';
    }
    // Get errorCode '19' from parameter like 'ec=ERR-19'
    const errorCode = getNumFromStr(errorParaStr);

    // If get valid errorCode
    if (errorCode && Number(errorCode) >= 0) {
        const errorCodeMsg = i18n.t(`ErrorMessages.error${errorCode}`);
        return getFullErrorMsg(errorCodeMsg);
    }
    return i18n.t('ErrorMessages.unknownErrorMessage');
};

const parseV4Error = error => {
    const errorAppMessages = error?.data?.getData?.()?.getError?.() || [];
    const errorCode = errorAppMessages?.[0]?.getCode?.();
    const errorMessage = errorAppMessages?.[0]?.getMessage?.();

    return {
        errorCode,
        errorMessage,
    };
};

const getV4ErrorMessage = (errorCode, apiErrorMessage) => {
    const errorMapper = errorCodeMapper?.[errorCode] || 'unknownErrorMessage';
    if (errorMapper.startsWith('error')) {
        return getFullErrorMsg(i18n.t(`ErrorMessages.${errorMapper}`));
    }
    if (errorCode === 'IAM-20009') {
        return apiErrorMessage || i18n.t(`ErrorMessages.${errorMapper}`);
    }
    return i18n.t(`ErrorMessages.${errorMapper}`);
};

export const handleV4Error = (error, callback) => {
    const { errorCode, errorMessage } = parseV4Error(error);

    if (errorRedirectMapper?.[errorCode]) {
        forceRedirect(errorRedirectMapper[errorCode]);
        return;
    }

    let message = getV4ErrorMessage(errorCode, errorMessage);

    callback?.(message);
};

/**
 * Handles inputs change to set values in state
 * @param {String} paras - props.location.search part
 * @returns {Boolean} if the error message comp should be showed
 */

export const shouldShowErrorMessage = paras => {
    // Only show error message when paras exist and find find 'ERR' in paras;
    // Don't show err when code num is 412;
    return paras && paras.indexOf('ERR') > -1 && paras.indexOf('412') === -1;
};
